export const SearchUrl = (): string => `/initial`;
export const CourseUrl = (id): string => `/workshops/${id}`;
export const LessonUrl = (courseId, lessonId): string =>
  `/workshops/${courseId}/lessons/${lessonId}`;
export const CookieRoute = (): string => `https://api.taalei-edu.com/sanctum/csrf-cookie`;
export const HomeUrl = (): string => `/home`;
export const LogoutUrl = (): string => `/logout`;
export const AllTermsUrl = (): string => `/terms`;
export const TermUrl = (id): string => `/terms/${id}`;
export const TermsInfoUrl = (): string => `/terms/intro`;
export const TermsOverviewsUrl = (id?: string): string =>
  `/terms/terms-overview${id ? `/${id}` : ''}`;
export const TermGroupUrl = (id): string => `/terms/${id}/preview`;
export const InstallmentPreviewUrl = (id): string => `/installments/${id}/preview`;
export const NewTermGroupUrl = (id?: number): string =>
  id ? `terms/terms-overview/${id}/details` : `/terms/preview`;
export const ReserveCallTimeUrl = (id): string => `/terms/${id}/reserve_call_times`;
export const CancelCallTimeUrl = (id, callId): string =>
  `/terms/${id}/cancel_call_time/${callId}`;
export const TermCallTimesUrl = (id): string => `/terms/${id}/available_call_times`;
export const TermScoreUrl = (id, page = 1): string => `/terms/${id}/scores?page=${page}`;
export const DiscussionGroupsUrl = (id): string => `/terms/${id}/discussion-groups`;
export const JoinDiscussionGroupsUrl = (id): string =>
  `/terms/${id}/join-discussion-group`;
export const PassedUrl = (courseId, lessonId): string =>
  `/workshops/${courseId}/lessons/${lessonId}/passed`;
export const discountUrl = (): string => `/takhfif-check`;
export const DirectPayUrl = (id, type): string => `/DirectPay/${type}/${id}`;
export const EventUrl = (id): string => `/events/${id}`;
export const CommentUrl = (id, page): string => `/workshops/${id}/comments?page=${page}`;
export const SendCommentUrl = (id, type): string => `/${type}/${id}/comments`;
export const SendQuestionUrl = (courseId, lessonId): string =>
  `/workshops/${courseId}/lessons/${lessonId}/questions`;
export const EventQuestionUrl = (id): string => `/events/${id}/questions`;
export const QuestionUrl = (id): string => `/workshops/${id}/questions`;
export const ExamInfoUrl = (examId): string => `/exams/${examId}/exam-review`;
export const ExamUrl = (examId): string => `/exams/${examId}/exam-questions`;
export const ExamResultUrl = (examId): string => `/exams/${examId}/submit-exam-answers`;
export const CreateQuestionUrl = (examId): string =>
  `/exams/${examId}/create_exam_question`;
export const EditQuestionUrl = (examId): string => `/exams/my_questions/${examId}/update`;
export const SendTicketUrl = (): string => `/user/tickets`;
export const MyCreateQuestionUrl = (page): string =>
  `/exams/exam_created_my_questions?page=${page}`;
export const SendNoteUrl = (courseId, lessonId): string =>
  `/workshops/${courseId}/lessons/${lessonId}/notes`;
export const SendTrainUrl = (courseId, lessonId): string =>
  `/workshops/${courseId}/lessons/${lessonId}/trainings`;
export const DeleteNoteUrl = (courseId, lessonId, noteId): string =>
  `/workshops/${courseId}/lessons/${lessonId}/notes/${noteId}`;
export const PostsUrl = (): string => `/posts`;
export const RateCourseUrl = (id): string => `/workshops/${id}/setRate`;
export const ChangeTermHoursUrl = (id): string => `/terms/${id}/update-setting`;
export const PayResultUrl = (): string => `/DirectPay/result`;
export const AppPayResultUrl = (): string => `/mobile-result-pay`;
export const GetCitiesUrl = (): string => `/province_cities`;
export const DiscountPackagesUrl = (): string => `/user/discountPackages`;
export const DiscountCodesUrl = (): string => `/user/discountCodes`;
export const ConvertScoreCreditUrl = (): string => `/user/convertScoreCredit`;
export const ShopRoute = (): string => `/shop`;

export const UserUrl = (): string => `/user`;
export const TicketUrl = (): string => `/user/tickets`;
export const TermsAcceptUrl = (): string => `/user/termsAccept`;
export const TicketChatUrl = (id): string => `/user/tickets/${id}/chats`;
export const SendTicketChatUrl = (id): string => `/tickets/${id}/chats`;
export const CloseTicketUrl = (id): string => `/user/tickets/${id}/close`;
export const MyTransactionsUrl = (id?): string => `/user/transactions?page=${id || 1}`;
export const MyCommentsUrl = (id?): string => `/user/comments?page=${id || 1}`;
export const MyTrainingUrl = (id?): string => `/user/trainings?page=${id || 1}`;
export const MyQuestionsUrl = (id?): string => `/user/questions?page=${id || 1}`;
export const ChangeUserImgUrl = (): string => `/user/change-avatar`;
export const ChangePasswordUrl = (): string => `/user/change-password`;
export const UpdateUserInfoUrl = (): string => `/user/profile-update`;
export const InstallmentsUrl = (): string => `/user/installments`;
export const UserTermsUrl = (): string => `/user/terms`;
export const UserScoresUrl = (id?): string => `user/scores?page=${id || 1}`;
export const AffiliateUrl = (): string => `/affiliateCode-check`;
export const SkillsUrl = (): string => `/counseling/skills`;
export const AdvisorUrl = (id): string => `/counseling/counselors/${id}`;
export const UserReserves = (): string => `/counseling/user/reserves`;
export const UserQuestions = (): string => `/counseling/user/questions`;
export const AvailableSessionsUrl = (id): string =>
  `/counseling/counselors/${id}/availableSessions`;
export const AdvisorQuestionUrl = (): string => `/counseling/questions`;
export const ReserveSessionsUrl = (id): string =>
  `/counseling/counselors/sessions/${id}/reserve`;
export const OfflineChatUrl = (id): string => `/counseling/questions/${id}/conversations`;
export const SendPublicQuestionUrl = (): string => `/counseling/public/questions`;
export const ConsultingQuestionUrl = (page: number, tag: string, sort: boolean): string =>
  `/counseling/public/questions?page=${page || 1}${tag ? `&tag=${tag}` : ''}${
    sort ? `&sort=views` : ''
  }`;
export const ConsultingHomeUrl = (): string => `/counseling/home`;
export const SingleQuestionUrl = (id): string => `/counseling/public/questions/${id}`;
export const PublicQuestionsUrl = (): string => `/counseling/user/publicQuestions`;
export const ConsultingUrl = (name?, id?): string =>
  `/counseling/counselors${
    name && !id
      ? `?name=${name}`
      : id && !name
      ? `?skill=${id}`
      : name && id
      ? `?name=${name}&skill=${id}`
      : ''
  }`;

// ///////////////////////////////////////////////////////////////

export const MobileVerifyUrl = (): string => `/verifyMobile`;
export const EmailVerifyUrl = (): string => `/verifyEmail`;
export const CheckAuthPhoneUrl = (): string => `/checkAuthPhone`;
export const CheckAuthEmailUrl = (): string => `/checkAuthEmail`;
export const LoginMobileUrl = (): string => `/loginUsingMobilePassword`;
export const LoginEmailUrl = (): string => `/loginUsingEmailPassword`;
export const FillFormUrl = (): string => `/RequiredFieldsFill`;
export const ForgetPasswordUrl = (): string => `/forget_password_step0`;
export const ForgetPasswordCodedUrl = (): string => `/forget_password_step1`;
export const ForgetPasswordNewUrl = (): string => `/forget_password_step2`;
export const ChangeMobileUrl = (): string => `/changeMobileOrEmail`;
export const ConfirmMobileUrl = (): string => `/confirm-MobileOrEmail`;
export const ChargeWalletUrl = (amount): string => `/DirectPay/wallet/${amount}`;

// //////////////////////////////////////////////////////////////////////////////////
export const HomeRoute = (): string => `/`;
export const AllPageRoute = (type): string => `/all/${type}/`;
export const CourseRoute = (id, name): string =>
  `/workshop/${id}/${name?.replace(/ /g, '-')}`;
export const CourseShortRoute = (id): string => `/workshop/${id}/a`;
export const EventShortRoute = (id): string => `/event/${id}`;
export const EventRoute = (id, name): string =>
  `/event/${id}/${name?.replace(/ /g, '-')}`;
export const LessonRoute = (courseId, lessonId, lessonName): string =>
  `/workshop/${courseId}/lesson/${lessonId}/${lessonName.replace(/ /g, '-')}`;
export const ProfileRoute = (id, name): string =>
  `/profile/${id}/${name?.replace(/ /g, '-')}`;
export const InstallmentsRoute = (): string => `/profile/installments`;

export const ExamInfoRoute = (examId): string => `/exam/${examId}/info`;
export const ExamRoute = (examId): string => `/exam/${examId}/question`;
export const DownloadRoute = (): string => `/download/`;
export const TestFlightRoute = (): string => `/download/test-flight`;
export const TermRegisterRoute = (id: number, isMain?: boolean): string =>
  `/term-register/${id}${isMain ? `?isMain=true` : ''}`;
// export const TermRoute = (isRegister, termId, termTitle): string => TermRegisterRoute();
export const TermRoute = (termId?, termTitle?): string =>
  termId
    ? `/term/${termId}/${termTitle?.replace(/ /g, '-')}/`
    : TermRegisterRoute(termId);
export const TermOverviewRoute = (): string => `/term-overview`;

export const ConditionRoute = (): string => `/privacy/`;
export const CooperateRoute = (): string => `https://taalei.ir/cooperate-with-us/`;
export const TicketRoute = (): string => `/profile/tickets`;
export const UserConsultingRoute = (): string => `/profile/consulting`;
export const FinanceRoute = (): string => `https://zarinp.al/taalei-edu.ir`;
export const CafebazaarRoute = (): string => `https://cafebazaar.ir/app/ir.taalei.app`;
export const DownloadUrl = (): string => `https://dl.taalei-edu.ir/taalei.apk`;
export const GooglePlayRoute = (): string =>
  `https://play.google.com/store/apps/details?id=ir.taalei.app`;
export const TelNumber = (): string => `0915 424 1197`;
export const ContactUsRoute = (): string => `/contact-us`;
export const PostsRoute = (): string => `/posts`;
export const ReturnAppRoute = (): string => `taalei_app://`;
export const TelegramShareRoute = (url): string =>
  `https://telegram.me/share/url?url=${url}`;
export const EitaaShareRoute = (url): string => `https://eitaa.com/share/url?url=${url}`;
export const WhatsappShareRoute = (url): string => `https://wa.me/send?text=${url}`;
export const WhatsappAskRoute = (): string =>
  `https://wa.me/989900014090?text=سلام. وقت بخیر! من از طریق سایت مدرسه تعالی با شما ارتباط میگیرم!`;
export const TelegramAskRoute = (): string => `https://t.me/ravabet_omumi_taalei`;
export const EitaaAskRoute = (): string => `https://eitaa.com/ravabet_omumi_taalei`;
export const TermLessonRoute = (termId, courseId, lessonId): string =>
  `/term-lesson/${termId}/${courseId}/${lessonId}`;
export const ConsultingRoute = (): string => `/consulting/`;
export const SingleQuestionRoute = (id): string => `/consulting/question/${id}`;
export const ConsultingConditionRoute = (): string => `/consulting/conditions`;
export const ConsultingQuestionsRoute = (tag?): string =>
  `/consulting/questions${tag ? `/?tag=${tag.replace(/ /g, '-')}` : ''}`;
export const ConsultingSearchRoute = (name, skill?): string =>
  `/consulting/search/?value=${name}${skill ? `&skill=${skill}` : ''}`;
export const AdvisorRoute = (id): string => `/consulting/advisor/${id}`;

export const Tel1 = '+989900014090';
export const Tel2 = '+989903021026';
